<div class="reportes-title">
  <app-title-pages-component
    [pageData]="pageData"
    [showDivider]="false"
  >
  </app-title-pages-component>
  <app-legend-nivel></app-legend-nivel>
</div>
